import React from 'react';
import { useWaitlistCount } from '../hooks/useWaitlistCount';
import { PartyPopper } from 'lucide-react';

interface WaitlistStatsProps {
  className?: string;
}

export function WaitlistStats({ className = '' }: WaitlistStatsProps) {
  const { count, loading, isAnimating } = useWaitlistCount();
  const goalSignups = 1500;
  const progress = (count / goalSignups) * 100;

  const getTierInfo = (count: number) => {
    if (count < 500) return { name: 'Grundare', spots: 500 - count };
    if (count < 1000) return { name: 'Pionjär', spots: 1000 - count };
    if (count < 1500) return { name: 'Tidig användare', spots: 1500 - count };
    return { name: 'Väntelista', spots: 0 };
  };

  const { name: currentTier, spots: remainingSpots } = getTierInfo(count);

  return (
    <div className={className}>
      <div className="flex items-center justify-between text-sm mb-2">
        <span className="font-medium text-gray-700">Utvecklingsstart</span>
        <span className="font-medium text-blue-600">
          {loading ? '...' : `${Math.round(progress)}% klart`}
        </span>
      </div>
      <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
        <div 
          className={`h-full bg-blue-600 rounded-full transition-all duration-500 ${
            isAnimating ? 'animate-pulse' : ''
          }`}
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="mt-3 flex justify-between items-center text-sm">
        <span className="text-gray-500">
          {loading ? 'Laddar...' : (
            <span className={`transition-all duration-300 ${isAnimating ? 'text-blue-600 font-medium scale-110' : ''}`}>
              {count} av {goalSignups} anmälda
              {isAnimating && (
                <PartyPopper className="inline-block ml-2 animate-bounce" size={16} />
              )}
            </span>
          )}
        </span>
        {remainingSpots > 0 && (
          <span className="text-blue-600 font-medium">
            {remainingSpots} {currentTier}-platser kvar
          </span>
        )}
      </div>
    </div>
  );
}